import React from 'react'

import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import ProfileConfirmation from 'app/PemetaanKompetensiPage/pages/ProfileConfirmation'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}

const PemetaanKompetensiKonfirmasiData = ({ currentDateTimeServer }) => {
  return <ProfileConfirmation currentDateTimeServer={currentDateTimeServer} />
}

const KonfirmasiDataPageHeader = () => (
  <PageHeader title="Konfirmasi Data Diri" />
)

PemetaanKompetensiKonfirmasiData.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: KonfirmasiDataPageHeader,
}

export default PemetaanKompetensiKonfirmasiData
